export * from '@primeuix/themes/material/tabview';
export { default } from '@primeuix/themes/material/tabview';
